import type { ReactNode } from 'react'

export interface HeaderAccentRailProps {
  menuItems?: string[]
  companyLabel?: string
  menuToggle?: ReactNode
}

/** Integrated nav strip below header — menu toggle + active path. */
export function HeaderAccentRail({
  menuItems = [],
  companyLabel,
  menuToggle,
}: HeaderAccentRailProps) {
  const showTrail = menuItems.length > 0
  const showCompany = Boolean(companyLabel?.trim())
  const currentLabel = showTrail ? menuItems[menuItems.length - 1] : 'Welcome'

  return (
    <div className="app-header-gloss-rail" aria-label="Current page">
      <div className="app-header-accent-rail__inner">
        {menuToggle ? (
          <span className="app-header-accent-rail__menu">{menuToggle}</span>
        ) : null}

        {menuToggle ? (
          <span className="app-header-accent-rail__divider" aria-hidden="true" />
        ) : null}

        <nav className="app-header-accent-rail__trail" aria-label="Navigation path">
          {showTrail ? (
            menuItems.map((label, index) => (
              <span key={`${label}-${index}`} className="app-header-accent-rail__segment">
                {index > 0 && (
                  <span className="app-header-accent-rail__sep" aria-hidden>
                    {' › '}
                  </span>
                )}
                <span
                  className={`app-header-accent-rail__crumb${
                    index === menuItems.length - 1 ? ' app-header-accent-rail__crumb--current' : ''
                  }`}
                  aria-current={index === menuItems.length - 1 ? 'page' : undefined}
                  title={label}
                >
                  {label}
                </span>
              </span>
            ))
          ) : (
            <span
              className="app-header-accent-rail__crumb app-header-accent-rail__crumb--current"
              aria-current="page"
            >
              {currentLabel}
            </span>
          )}
        </nav>

        {showCompany && (
          <>
            <span className="app-header-accent-rail__divider app-header-accent-rail__divider--trail" aria-hidden="true" />
            <div className="app-header-accent-rail__company" title="Selected company">
              <span className="app-header-accent-rail__company-dot" aria-hidden />
              <span className="app-header-accent-rail__company-name">{companyLabel}</span>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
